import axios from 'axios';
import { apiPath } from '../../utils/api-contants';
import axiosClient from './axiosClient';

const BASE_URL: any = apiPath.USECASE_MGMNT; // Use the correct base URL for your API

class UseCaseBuilderService {
  // Fetch Use Case Data
  async getUseCaseData(params: any) {
    const response = await axiosClient.get(`${BASE_URL}/get`, { params });
    return { data: response.data, code: response?.status }
  }

  async getDeployedUsecase(params: any) {
    const updatedParams = { ...params, filter_status: 'deployed' }; // Always include filter_status: 'deployed'
    const response = await axiosClient.get(`${BASE_URL}/get`, { params: updatedParams });
    return { data: response.data, code: response?.status };
  }


  // Add Use Case
  async addUseCase(useCase: any) {
    const response = await axiosClient.post(`${BASE_URL}/create`, useCase);
    return { data: response.data, code: response?.status }
  }

  // Update Use Case
  async updateUseCase(useCase: any) {
    // /${useCase.id}
    const response = await axiosClient.patch(`${BASE_URL}/update`, useCase);
    return { data: response.data, code: response?.status }
  }

  async updateUseCaseAccess(useCase: any) {
    // /${useCase.id}
    const response = await axiosClient.patch(`${BASE_URL}/update_user_access`, useCase);
    return { data: response.data, code: response?.status }
  }

  // Delete Use Case
  async deleteUseCase(deletePayload:any) {
    const response = await axiosClient.delete(`${BASE_URL}/delete/${deletePayload.id}?forced_delete=${deletePayload.forced_delete}`);
    return response;
  }

  async approveUseCase(payload: any) {
    const response = await axiosClient.patch(`${BASE_URL}/approve`, payload);
    return response;
  }

  // Fetch Custom JSON Templates
  async getCustomJsonTemplates(params: any) {
    const response = await axiosClient.get(`${BASE_URL}/templates`, { params });
    return response;
  }

  // Add Custom JSON Template
  async addCustomJsonTemplate(template: any) {
    const response = await axiosClient.post(`${BASE_URL}/template`, template);
    return response;
  }

  // Update Custom JSON Template
  async updateCustomJsonTemplate(template: any) {
    const response = await axiosClient.patch(`${BASE_URL}/template/${template.template_id}`, template);
    return response;
  }

  async updateDefaultDashboard(payload: any) {
    const response = await axiosClient.patch(`${BASE_URL}/update_default_dashboard`, payload);
    return response;
  }

  // Delete Custom JSON Template
  async deleteCustomJsonTemplate(template_data: any) {
    const response = await axiosClient.delete(`${BASE_URL}/template/${template_data.id}?forced_delete=${template_data.forced_delete}`);
    return response;
  }

  async updateUseCaseOntologyFilter(payload: any) {
    const response = await axiosClient.put(`${BASE_URL}/update_ontology_filter/${payload.id}`, { last_selected_onto_manage_id: payload.onto_manage_id });
    return { data: response.data, code: response?.status }
  }
}

export default new UseCaseBuilderService();